export default "__VITE_ASSET__TWdDoFCP__"